import {
  Brain,
  ForkKnife,
  Heartbeat,
  Moon,
  PersonSimpleRun,
  type Icon as PhosphorIcon,
  UsersThree,
} from "@phosphor-icons/react";

export type LogbookTab = "food" | "connection" | "stress" | "movement" | "sleep" | "health";

export const LOGBOOK_TABS: ReadonlyArray<{ id: LogbookTab; label: string; Icon: PhosphorIcon }> = [
  { id: "food", label: "Food", Icon: ForkKnife },
  { id: "connection", label: "Connection", Icon: UsersThree },
  { id: "stress", label: "Stress", Icon: Brain },
  { id: "movement", label: "Movement", Icon: PersonSimpleRun },
  { id: "sleep", label: "Sleep", Icon: Moon },
  { id: "health", label: "Health", Icon: Heartbeat },
];

/**
 * The same underline-register tabs Snapshot uses for Overview/Sleep/
 * Recovery/Strain/Body/Sources (`snapshot-tabs.tsx`'s `SnapshotTabs`) —
 * reuses its exact `snap-tabs` CSS class and markup shape rather than a
 * second, Logbook-specific style, so the two pages' section tabs read as
 * the same control.
 */
export function LogbookTabs({
  value,
  onChange,
}: {
  value: LogbookTab;
  onChange: (next: LogbookTab) => void;
}) {
  return (
    <nav className="snap-tabs" aria-label="Logbook sections">
      {LOGBOOK_TABS.map(({ id, label, Icon }) => (
        <button key={id} type="button" aria-pressed={value === id} onClick={() => onChange(id)}>
          <Icon size={13} aria-hidden="true" />
          {label}
        </button>
      ))}
    </nav>
  );
}
